<template>
  <div class="content-box">
    <div class="title">
      <h2>{{ title }}</h2>

      <el-link
        v-if="this.more.name != ''"
        :href="this.more.url"
        target="_blank"
        :underline="false"
      >
        {{ this.more.name }}</el-link
      >
    </div>
    <div class="title-right">
      <a class="left-img" href="https://www.100ec.cn/detail--6649395.html">
        <img
          src="https://www.100ec.cn/Public/home/images/2024szjybq.gif"
        />
      </a>
    </div>
    <!-- <div class="title-right">
      <a class="left-img" href="https://www.chinaacc.com/zhuanti/618/" target="_blank">
        <img
          src="https://www.100ec.cn/Public/home/images/jygg/960.jpg?v=1.0"
        />
      </a>
    </div> -->
        <!-- <div class="adv">
      <a class="left-img" href="https://www.100ec.cn/zt/wswjsxfpgyl/">
        <img src="https://www.100ec.cn/zt/wswjsxfpgyl/img/960gg.gif" />
      </a>
    </div> -->
    <div>
      <a class="lj" href="http://www.100ec.cn/edunav/">
        <div>网课超市</div>
        <img
          src="http://www.100ec.cn/Public/home/images/hot.png"
          width="20px"
        />
      </a>
    </div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        :index="String(index + 1)"
        v-for="(i, index) of dataNav"
        :key="index"
        @click="handleSelect(index)"
      >
        {{ i.label }}</el-menu-item
      >
    </el-menu>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in dataNav"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <Textlist />

  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
    return {
      activeIndex: "1",
      name: "滚动播报",
      title: "",
      more: {
        name: "",
        url: "",
      },
      dataNav: [
        {
          value: 5,
          label: "滚动播报",
        },
        {
          value: "数字 教育",
          label: "数字教育",
        },
        {
          value: "K12",
          label: "K12",
        },
        {
          value: "AI教育",
          label: "AI教育",
        },
        {
          value: "职业教育",
          label: "职业教育",
        },
        {
          value: "早教",
          label: "早教",
        },
        {
          value: "在线英语",
          label: "在线英语",
        },
        {
          value: "数理思维",
          label: "数理思维",
        },
        {
          value: "编程",
          label: "在线编程",
        },
        {
          value: "高等教育",
          label: "高等教育",
        },
        {
          value: "OMO",
          label: "OMO",
        },
        {
          value: "大班课",
          label: "大班课",
        },
        {
          value: "小班课",
          label: "小班课",
        },
        {
          value: "1v1",
          label: "1v1",
        },
        {
          value: "知识付费",
          label: "知识付费",
        },
        {
          value: "智慧校园",
          label: "智慧校园",
        },
        {
          value: "游戏化学习",
          label: "游戏化学习",
        },
        {
          value: "电诉宝 教育",
          label: "曝光台",
        },
        {
          value: "双减",
          label: "双减",
        },
        {
          value: "教育部",
          label: "教育部",
        },
      ],
      params: {
        json: 2,
        filter: [
          "研报",
          "分析",
          "（PPT）",
          "（全文）",
          "实战：",
          "曹磊",
          "陈礼腾",
          "蒙慧欣",
        ],
      },
    };
  },
  created() {
    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", this.dataNav[0].value);
    this.$store.dispatch("getText");
    this.$store.state.allNav.forEach((item) => {
      item.child.forEach((j) => {
        if (this.$route.path.indexOf(j.url) != -1) {
          this.title = j.name;
          if (this.title == "首页") {
            this.title = "热点聚焦";
          }

          if (item.more != undefined) {
            this.more = item.more;
          } else if (j.more != undefined) {
            this.more = j.more;
          }
        }
      });
    });
  },
  methods: {
    handleSelect(index) {
      if (typeof this.dataNav[index].value == "number") {
        this.params.json = 2;
      } else if (this.dataNav[index].value == "电诉宝在线教育") {
        this.params.json = 1;
      } else {
        this.params.json = 0;
      }
      this.$store.commit("textparams", this.params);
      this.$store.commit("changeKeys", this.dataNav[index].value);
      this.$store.dispatch("getText");
    },
    handleSelect2(value) {
      if (typeof value == "number") {
        this.params.json = 2;
      } else if (value == "电诉宝在线教育") {
        this.params.json = 1;
      } else {
        this.params.json = 0;
      }
      this.$store.commit("textparams", this.params);
      this.$store.commit("changeKeys", value);
      this.$store.dispatch("getText");
    },
  },
};
</script>
<style scoped>
.title {
  position: relative;
}
.title-right {
  display: flex;
  position: absolute;
  left: 195px;
  top: 65px;
}
.title-right .left-img img {
  width: 500px;
  height: 70px;
  margin-right: 20px;
}
.lj {
  display: flex;
  color: #303133;
  font-size: 16px;
  padding: 20px 2px;
  position: absolute;
  width: 60px;
  top: 70px;
  right: 20px;
}
.lj img {
  width: 25px;
  height: 20px;
}

.lj:hover {
  color: #ff6a04;
  border-bottom: 2px solid #ff6a04;
}
.adv {
  display: none;
}
@media (max-width: 1100px) {
  .adv {
    display: block;
  }
  .title-right {
    position: static;
    margin: 10px 0;
  }
  .title-right .left-img img {
    width: 100%;
    height: 50px;
  }
  .lj {
    display: flex;
    color: #303133;
    font-size: 16px;
    padding: 20px 2px;
    position: absolute;
    width: 60px;
    right: 15px;
    top: -15px;
  }
}
</style>